import React, { useEffect, useState } from "react";
import CustomSnackbar from "@Components/Snackbar/Snackbar";
import { CssBaseline } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/system";
import AppRoutes from './AppRoutes/AppRoutes';
import themeCreator from "./Themes/themeCreator";
import { checkAllUsersOldMessages } from '@Utils/storageUtils';
import MobileView from "./Pages/MobileView/MobileView.";

function App() {
  const [isBlockedDevice, setIsBlockedDevice] = useState(false);

  const theme = useTheme();
  const customTheme = themeCreator(theme);

  const checkDeviceSize = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Block if either is too small
    if (width <= 950 || height <= 500) {
      setIsBlockedDevice(true);
    } else {
      setIsBlockedDevice(false);
    }
  };

  useEffect(() => {
    checkDeviceSize(); // Initial check
    window.addEventListener("resize", checkDeviceSize);
    return () => window.removeEventListener("resize", checkDeviceSize);
  }, []);

  useEffect(() => {
    checkAllUsersOldMessages();
  }, []);

  if (isBlockedDevice) {
    return <MobileView />;
  }

  return (
    <ThemeProvider theme={customTheme}>
      <CssBaseline />
      <div className="App">
        <AppRoutes />
      </div>
      <CustomSnackbar />
    </ThemeProvider>
  );
}

export default App;
